(function () {

    "use strict";

    function fileItemController(URL, $http, $mdToast, $translate) {
        var vm = this;
        vm.files = [];

        vm.$onInit = function () {
            vm.idFile = "fileInput_" + vm.entity.id;
            if (vm.entity.files != null) {
                vm.files.push(vm.entity.files);
                vm.stateOkDoc = true;
                vm.createDoc = false;
            }else {
                vm.createDoc = true;
            }
        };

        vm.onSelectedFileEvent = function (files, invalidFiles) {

            if (null != files && files.length > 0) {
                vm.invalidFiles = invalidFiles;
                vm.entity.ficheros = vm.files;
                vm.entity.save(vm.entity).then(function (data) {
                    if (data != null) {
                        vm.files = [];
                        vm.files = data.ficheros;
                        vm.files[0].id = data.id;
                        vm.stateOkDoc = true;
                    }
                });

            } else {
                vm.files = [];
                $mdToast.show($mdToast.simple().textContent($translate.instant("COMUN.PROCESSFINALPRODUCTO"))
                    .position('top right').theme('error-toast').hideDelay(3000));
            }

        };
        vm.addFile = function () {
            setTimeout(function () {
                document.getElementById(vm.idFile).click();
            }, 0);
        };

        vm.downloadDoc = function () {
            if (vm.files[0].type == "fileItem") {

                $http({
                    url: URL.URL + "/api/download/fileitems/" + vm.files[0].idFileContainer,
                    method: "POST",
                    data: {
                        name: vm.files[0].Texto_ES,
                        items: vm.files,
                        isFolder: false,
                        metadataGroupingItems: []
                    },
                    responseType: 'arraybuffer'
                }).then(function (data) {
                    saveAs(new Blob([data.data], { type: 'application/octet-stream' }), vm.files[0].name);
                }, function (error) {
                    console.log(error);
                });

            } else {
                var a = document.createElement("a");
                var file = new Blob([vm.files[0]], { type: vm.files[0].type });
                var fileURL = window.URL.createObjectURL(file);
                a.href = fileURL;
                a.download = vm.files[0].name;
                a.click();
            }
        };
    }

    fileItemController.$inject = ["URL", "$http", "$mdToast", "$translate"];

    angular.module("sphforms.main")
        .component("sphFormsFileitem", {
            controller: fileItemController,
            bindings: {
                disable: "=",
                entity: "="
            },
            templateUrl: "modules/main/components/ui/fileItem/fileItem.template.html"
        });
}());
